import { observer } from 'mobx-react';
import React, { Component, DragEvent, MouseEvent } from 'react';
import { IEcoli } from 'stores/models/Ecoli';

interface IProps {
  isDraggable: boolean;
  model: IEcoli;
  onDragStart: () => void;
}

interface IState {
  isMouseDown: boolean;
}

class View extends Component<IProps, IState> {
  defaultState: IState = { isMouseDown: false };

  constructor(props: IProps) {
    super(props);

    this.state = this.defaultState;
  }

  private onDragStart = (e: DragEvent<HTMLDivElement>): void => {
    const { model, onDragStart } = this.props;

    onDragStart();

    e.dataTransfer.setData(model.info.type, model.id);
    this.setState({ isMouseDown: false });
  };

  private onMouseDown = (e: MouseEvent<HTMLDivElement>): void => {
    this.setState({ isMouseDown: true });
  };

  private onMouseUp = (e: MouseEvent<HTMLDivElement>): void => {
    this.setState({ isMouseDown: false });
  };

  render() {
    const { children, isDraggable } = this.props;
    const { isMouseDown } = this.state;
    const styleActive = isMouseDown ? 'is-active' : '';

    return (
      <div
        className={`ecoli-draggable is-flex-centered is-unselectable h-100p ${
          isDraggable ? 'is-draggable opacity-100p' : 'is-grayscale opacity-20p'
        } ${styleActive}`}
        draggable={isDraggable}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
      >
        <div className='ecoli-draggable-gfx is-flex-centered'>{children}</div>
      </div>
    );
  }
}

const EcoliDraggable = observer(View);
export default EcoliDraggable;
